import VideoCover from "./VideoCover"

export default VideoCover
